import "./ItemDetailsTable.scss";
import { useRef } from "react";
import MediaQuery from "react-responsive";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "../../../../../../../hooks";
import { getCountryName } from "../../../../../../../utils/helpers/getCountryName";
import { getCountryFlag } from "../../../../../../../utils/helpers/getCountryFlag";
import { getDateFormat } from "../../../../../../../utils/helpers/getDateFormat";

export const ItemDetailsTable = ({ isOpen, detailedInfo }) => {
  const { lang } = useParams();
  const { countries } = useSelector((state) => state.content);
  const { main: { selectProxy }, cabinet: { balance: { detailPayment } } } = useTranslation();

  const tableContainerRef = useRef();

  const getTableHeight = () => {
    if (!tableContainerRef.current) return;

    return tableContainerRef.current.scrollHeight || 0;
  };

  const formatDate = (dateString) => {
    if (!dateString) return;

    const date = new Date(dateString);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return {
      date: `${day}.${month}.${year}`,
      time: `${hours}:${minutes}`
    };
  };

  return (
    <div
      style={{ maxHeight: isOpen ? getTableHeight() : 0 }}
      className="details-table">
      <div className="details-table-container" ref={tableContainerRef}>
        <MediaQuery maxWidth={992}>
          <>
            {detailedInfo?.items?.map((item) => (
              // eslint-disable-next-line react/jsx-key
              <div className="details-table__card">
                <div className="details-table__field">
                  <div className="details-table__card-heading">{detailPayment.type}</div>
                  <div className="details-table__card-value">{selectProxy[item.proxyType]}</div>
                </div>
                <div className="details-table__field">
                  <div className="details-table__card-heading">{detailPayment.country}</div>
                  <div className="details-table__card-value details-table__card-value--country">
                    <span className="flag">{getCountryFlag(item?.country?.code, countries?.data, lang)}</span>
                    {getCountryName(item?.country?.code, lang, countries?.data)}
                  </div>
                </div>
                <div className="details-table__field">
                  <div className="details-table__card-heading">{detailPayment.quantity}</div>
                  <div className="details-table__card-value">{item?.count}</div>
                </div>
                <div className="details-table__field">
                  <div className="details-table__card-heading">{detailPayment.term}</div>
                  <div className="details-table__card-value">{getDateFormat(item?.days, lang)}</div>
                </div>
                <div className="details-table__field">
                  <div className="details-table__card-heading">{detailPayment.orderDate}</div>
                  <div className="details-table__card-value details-table__date">{formatDate(item?.date).date} <span className="">{formatDate(item?.date).time}</span></div>
                </div>
              </div>
            ))}
          </>

        </MediaQuery>
        <MediaQuery minWidth={993}>
          <table className="details-table__table">
            <thead className="details-table__head">
            <tr>
              <th className="details-table__payment">{detailPayment.type}</th>
              <th className="details-table__country">{detailPayment.country}</th>
              <th className="details-table__quantity">{detailPayment.quantity}</th>
              <th className="details-table__term">{detailPayment.term}</th>
              <th className="details-table__order-date">{detailPayment.orderDate}</th>
            </tr>
            </thead>
            <tbody>
            {detailedInfo?.items?.map((item, index) => (
              <tr key={index}>
                <td className="details-table__payment">{selectProxy[item.proxyType]}</td>
                <td className="country details-table__country">
                  <span className="flag">{getCountryFlag(item?.country?.code, countries?.data, lang)}</span>
                  {getCountryName(item?.country?.code, lang, countries?.data)}
                </td>
                <td className="details-table__quantity">{item?.count}</td>
                <td className="details-table__term">{getDateFormat(item?.days, lang)}</td>
                <td className="details-table__date details-table__order-date">{formatDate(item?.date).date} <span>{formatDate(item?.date).time}</span></td>
              </tr>
            ))}
            </tbody>
          </table>
        </MediaQuery>
      </div>
    </div>
  );
};
